// src/admin/pages/AdminReportsMain.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import '../../styles/AdminReportsMain.css';

const AdminReportsMain = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="admin-reports-main-page" dir="rtl">
      <AdminSidebar />
      <div className="admin-reports-main-content">
        <AdminHeader title="التقارير الرئيسية" />
        
        <div className="report-cards-container">
          <div className="report-category">
            <h2>تقارير التشغيل</h2>
            <div className="report-cards">
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/operations/orders')}>
                <div className="report-card-icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
                <div className="report-card-content">
                  <h3>تقارير الطلبات</h3>
                  <p>عرض تفاصيل الطلبات والإحصائيات المتعلقة بالطلبات المكتملة والملغاة</p>
                </div>
              </div>
              
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/operations/restaurants')}>
                <div className="report-card-icon">
                  <i className="fas fa-store"></i>
                </div>
                <div className="report-card-content">
                  <h3>تقارير المطاعم</h3>
                  <p>تحليل أداء المطاعم وعدد الطلبات والإيرادات</p>
                </div>
              </div>
              
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/operations/drivers')}>
                <div className="report-card-icon">
                  <i className="fas fa-motorcycle"></i>
                </div>
                <div className="report-card-content">
                  <h3>تقارير السائقين</h3>
                  <p>تحليل أداء السائقين وعدد الطلبات وأوقات التوصيل</p>
                </div>
              </div>
              
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/operations/summary')}>
                <div className="report-card-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <div className="report-card-content">
                  <h3>التقرير التشغيلي الشامل</h3>
                  <p>نظرة عامة على جميع العمليات والمؤشرات الرئيسية للأداء</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="report-category">
            <h2>التقارير المالية</h2>
            <div className="report-cards">
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/finance/revenue')}>
                <div className="report-card-icon">
                  <i className="fas fa-money-bill-wave"></i>
                </div>
                <div className="report-card-content">
                  <h3>تقارير الإيرادات</h3>
                  <p>تحليل الإيرادات حسب الفترات الزمنية وطرق الدفع والمطاعم</p>
                </div>
              </div>
              
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/finance/restaurants')}>
                <div className="report-card-icon">
                  <i className="fas fa-wallet"></i>
                </div>
                <div className="report-card-content">
                  <h3>تقارير أرصدة المطاعم</h3>
                  <p>تفاصيل عمليات الشحن والاستهلاك وأرصدة المطاعم</p>
                </div>
              </div>
              
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/finance/drivers')}>
                <div className="report-card-icon">
                  <i className="fas fa-file-invoice-dollar"></i>
                </div>
                <div className="report-card-content">
                  <h3>تقارير مالية السائقين</h3>
                  <p>رسوم التوصيل وإيرادات السائقين والمستحقات</p>
                </div>
              </div>
              
              <div className="report-card" onClick={() => handleNavigate('/admin/reports/finance/summary')}>
                <div className="report-card-icon">
                  <i className="fas fa-chart-pie"></i>
                </div>
                <div className="report-card-content">
                  <h3>التقرير المالي الشامل</h3>
                  <p>نظرة عامة على جميع المعاملات المالية والإحصاءات</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminReportsMain;